import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  //authDomain: "avisamesibaja-be02c.firebaseapp.com",
  authDomain: "www.avisamesibaja.com",
  projectId: "avisamesibaja-be02c",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app); // 👈 esto es lo que hace falta

export { db, auth, storage };

